import type { TImporterState } from '@feathr/blackbox';

/*
 * A failed import is not a dead end: the usual recovery is to re-upload a
 * corrected file and run it again, so the wizard stays editable and the
 * Import/Save actions stay enabled in that state as well as in 'draft'.
 * 'pending' and 'processing' are in flight and 'complete' is done, so all three stay locked.
 */
const EDITABLE_STATES = new Set<TImporterState>(['draft', 'failed']);

export function isImporterEditable(state?: TImporterState): boolean {
  return !!state && EDITABLE_STATES.has(state);
}

/*
 * The campaign "Import contacts" buttons add this to the wizard URL. That import feeds a
 * campaign group, so it is always a contact import and step 1 offers no type choice.
 */
const CONTACTS_ONLY_PARAM = 'type';
const CONTACTS_ONLY_VALUE = 'contacts';

export function getContactsOnlyImportUrl(url: string): string {
  return `${url}?${new URLSearchParams({ [CONTACTS_ONLY_PARAM]: CONTACTS_ONLY_VALUE })}`;
}

export function isContactsOnlyImport(search: string): boolean {
  return new URLSearchParams(search).get(CONTACTS_ONLY_PARAM) === CONTACTS_ONLY_VALUE;
}
